import React, { useState } from 'react';
import LiveCount from './LiveCount';
import { trackUserInteraction } from '../utils/analytics';
import './LandingPage.css';

const LandingPage = ({ onJoinSession, onWaitForNext, audioEnabled, onAudioToggle }) => {
  const [selectedOption, setSelectedOption] = useState('');

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  const handleContinue = () => {
    if (selectedOption === 'join') {
      trackUserInteraction('Join Current Session', { label: 'Landing Page' });
      onJoinSession();
    } else if (selectedOption === 'wait') {
      trackUserInteraction('Wait for Next Session', { label: 'Landing Page' });
      onWaitForNext();
    }
  };

  return (
    <div className="landing-container">
      <LiveCount />
      <div className="landing-content">
        <h1 className="landing-title">World Rosary</h1>
        <p className="landing-subtitle">
          Join millions around the world in synchronized prayer!
        </p>
        
        <div className="landing-options">
          
          <div className="option-cards">
            <div 
              className={`option-card ${selectedOption === 'join' ? 'selected' : ''}`}
              onClick={() => handleOptionSelect('join')}
            >
              <div className="option-icon">🙏</div>
              <h3 className="option-title">Join Current Session</h3>
              <p className="option-description">
                Jump into the rosary prayer that's currently in progress. 
                You'll join millions of Catholics praying together right now.
              </p>
              <div className="option-status">
                <span className="status-indicator live">●</span>
                <span className="status-text">Live Prayer in Progress</span>
              </div>
            </div>

            <div 
              className={`option-card ${selectedOption === 'wait' ? 'selected' : ''}`}
              onClick={() => handleOptionSelect('wait')}
            >
              <div className="option-icon">⏰</div>
              <h3 className="option-title">Wait for Next Session</h3>
              <p className="option-description">
                Wait for the next scheduled rosary session to begin. 
                New sessions start every 30 minutes on the hour and half hour.
              </p>
              <div className="option-status">
                <span className="status-indicator upcoming">●</span>
                <span className="status-text">Next Session Starting Soon</span>
              </div>
            </div>
          </div>
        </div>

        <div className="audio-settings">
          <h3 className="audio-title">Pray Rosary Outloud?</h3>
          <div className="audio-toggle">
            <label className="radio-label">
              <input
                type="radio"
                name="audio"
                value="on"
                checked={audioEnabled}
                onChange={() => {
                  trackUserInteraction('Audio Toggle', { label: 'Audio ON' });
                  onAudioToggle(true);
                }}
              />
              <span className="radio-custom"></span>
              <span className="radio-text">🔊 YES</span>
            </label>
            <label className="radio-label">
              <input
                type="radio"
                name="audio"
                value="off"
                checked={!audioEnabled}
                onChange={() => {
                  trackUserInteraction('Audio Toggle', { label: 'Audio OFF' });
                  onAudioToggle(false);
                }}
              />
              <span className="radio-custom"></span>
              <span className="radio-text">🔇 NO</span>
            </label>
          </div>
        </div>

        <button 
          className={`continue-button ${selectedOption ? 'enabled' : 'disabled'}`}
          onClick={handleContinue}
          disabled={!selectedOption}
        >
          {selectedOption === 'join' ? 'Join Prayer Now' : 
           selectedOption === 'wait' ? 'Wait for Next Session' : 
           'Please Select an Option'}
        </button>

        <div className="landing-info">
          <p>New rosary sessions begin every 30 minutes on the hour and half hour</p>
          <p>All prayers are synchronized worldwide</p>
        </div>
      </div>

      <footer className="landing-footer">
        <div className="footer-content">
          <div className="footer-links">
            <a href="/privacy" className="footer-link">Privacy Policy</a>
            <span className="footer-separator">•</span>
            <a href="/terms" className="footer-link">Terms of Service</a>
            
          </div>
          <p className="landing-info">Made with ❤️ in Phoenix, Arizona USA</p>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
